import { getCurrentLanguage, getNavigatorLanguage, LANGUAGES, setCurrentLanguage } from "../../utils/language";
import moment from "moment";

if (getCurrentLanguage() != null) {
    moment.locale(getCurrentLanguage().code);
}

const language = {
    namespaced: true,
    state: {
        languages: LANGUAGES,
        language: getCurrentLanguage(),
    },
    mutations: {
        SET_LANGUAGE: (state, language) => {
            state.language = language;
            setCurrentLanguage(language);
        },
    },
    actions: {
        setLanguage({ commit, state }, code) {
            const lang = state.languages.find((language) => language.code === code) || getNavigatorLanguage();
            commit("SET_LANGUAGE", lang);
        },
    },
};

export default language;
